module.exports = __webpack_public_path__ + "static/media/reminder.5b9cb1d9.svg";